import * as React from "react";
import { last } from "lodash";
import { useParameter, useDictionaryItem } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";

export function useSlideTitle() {
  const [commodities] = useParameter<number[]>("@commodities_display");
  const [commName, setCommName] = React.useState("");
  const [commodityItem, commodityName] = useDictionaryItem(dictionaryService, "slides-commodities-display", Number(last(commodities)), {
    business_unit: 1,
    slide: 25,
  });
  React.useEffect(() => {
    if (commodityItem && commodityName) {
      setCommName(commodityName[9]);
    }
  }, [commodityItem, commodityName]);

  const title = `AP major crops by lead countries – ${commName} self sufficiency, consumption per capita`;
  return title;
}
